import React from "react"
import { Badge, DropdownToggle } from "reactstrap"
import FilterWrapper from "components/common/FilterWrapper"
import Input from "components/form/Input"
import { useTranslation } from "react-i18next"
import { TRIP_FILTERS, TRIP_FILTERS_HELP_ATTRIBUTES } from "constants/trip"
import { ChevronDown } from "react-feather"
import { Flex } from "antd"
import { Text } from "ui/Typography"
import styles from "./Sort.module.scss"

export default function Sort() {
  const { t } = useTranslation()

  return (
    <FilterWrapper
      title={t("filterTags.sort_by_distance")}
      fields={["price_per_person_sort", "skill_level_sort"]}
      accessAttributes={TRIP_FILTERS}
      exceptDependencies={TRIP_FILTERS_HELP_ATTRIBUTES}
      toggleButton={(isOpen, isActive, filters) => {
        const badge = Object.keys(filters)?.length || null
        return (
          <DropdownToggle className={`${styles.DropdownToggle} px-m`} color="icon">
            <Flex gap={10}>
              <Text className={styles.label}>{t("filterTags.sort_by_distance_nearest")}</Text>
              <ChevronDown />
            </Flex>
            {!!badge && (
              <Badge
                color="white"
                className={`d-block position-absolute top-auto bottom-100 start-0 mb-n2 text-primary-second text-center fw-normal lh-1 border border-primary-second ${styles.badgeMinWidth}`}
              >
                {badge}
              </Badge>
            )}
          </DropdownToggle>
        )
      }}
    >
      {(form, changeHandler) => (
        <>
          <Text strong className="mb-3">
            {t("filterTags.price")}
          </Text>
          <Flex vertical gap={2}>
            <Text
              check
              className={`hstack gap-10 p-10 pe-15 bg-white border ${
                form.price_per_person_sort === "asc" ? "border-gray" : "border-gray-lightest"
              } rounded fs-7 fw-normal`}
            >
              <Input
                type="radio"
                name="price_per_person_sort"
                value="asc"
                checked={form.price_per_person_sort === "asc"}
                onChange={changeHandler}
                className="mt-0"
              />
              <span className={`text-dark ${form.price_per_person_sort === "asc" ? "" : "text-opacity-50"}`}>
                {t("filterTags.price_asc")}
              </span>
            </Text>
            <Text
              check
              className={`hstack gap-10 p-10 pe-15 bg-white border ${
                form.price_per_person_sort === "desc" ? "border-gray" : "border-gray-lightest"
              } rounded fs-7 fw-normal`}
            >
              <Input
                type="radio"
                name="price_per_person_sort"
                value="desc"
                checked={form.price_per_person_sort === "desc"}
                onChange={changeHandler}
                className="mt-0"
              />
              <span className={`text-dark ${form.price_per_person_sort === "desc" ? "" : "text-opacity-50"}`}>
                {t("filterTags.price_desc")}
              </span>
            </Text>
          </Flex>

          <Text strong className="my-s">
            {t("filterTags.distance")}
          </Text>
          <div className="vstack gap-2 mb-4">
            <Text
              check
              className={`hstack gap-10 p-10 pe-15 bg-white border ${
                form.distance_sort === "asc" ? "border-gray" : "border-gray-lightest"
              } rounded fs-7 fw-normal`}
            >
              <Input
                type="radio"
                name="distance_sort"
                value="asc"
                checked={form.distance_sort === "asc"}
                onChange={changeHandler}
                className="mt-0"
              />
              <span className={`text-dark ${form.distance_sort === "asc" ? "" : "text-opacity-50"}`}>{t("filterTags.nearest_first")}</span>
            </Text>
            <Text
              check
              className={`hstack gap-10 p-10 pe-15 bg-white border ${
                form.distance_sort === "desc" ? "border-gray" : "border-gray-lightest"
              } rounded`}
            >
              <Input
                type="radio"
                name="distance_sort"
                value="desc"
                checked={form.distance_sort === "desc"}
                onChange={changeHandler}
                className="mt-0"
              />
              <span className={`text-dark ${form.distance_sort === "desc" ? "" : "text-opacity-50"}`}>
                {t("filterTags.farthest_first")}
              </span>
            </Text>
          </div>
        </>
      )}
    </FilterWrapper>
  )
}
